<div class="container">
  <div>
    <app-overdue-visits #overdueVisitsContainer [hidden]="!overdueTabSelected"></app-overdue-visits>
    <app-upcoming-visits #upcomingVisitsContainer [hidden]="!upcomingTabSelected"></app-upcoming-visits>
  </div>
</div>

